module.exports = __webpack_public_path__ + "img/certificado.e66049ba.png";